export const translateCountryToLocale = ({ lang, country }) => {
  if (!country) {
    return '';
  }

  const regionNames = new Intl.DisplayNames([lang], { type: 'region' });

  return regionNames.of(country) ? regionNames.of(country) : country;
};
